import * as ActionType from '../actions/types'

const apiErrorReducer = (state = null, action) => {
  switch (action.type) {
    case ActionType.SHOW_API_ERROR:
    case ActionType.HIDE_API_ERROR:
      // console.log('update error info - ', action.type, ': ', action.payload)
      return action.payload

    default:
      return state
  }
}

export default apiErrorReducer
